import { render, staticRenderFns } from "./SelectLabels.vue?vue&type=template&id=5595884e&"
import script from "./SelectLabels.vue?vue&type=script&lang=js&"
export * from "./SelectLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports